import axios from 'axios';
import * as SETTINGS from '../../settings';

export default {
  getCategories(cb) {
    axios
      .get(
        SETTINGS.API_BASE_PATH +
          'categories?sort=name&hide_empty=true&per_page=50'
      )
      .then(response => {
        cb(response.data.filter(c => c.name !== 'Uncategorized'));
      })
      .catch(e => {
        cb(e);
      });
  },

  getPages(cb) {
    axios
      .get(SETTINGS.API_BASE_PATH + 'pages?per_page=10')
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        cb(e);
      });
  },

  getPage(id, cb) {
    if(!Number.isInteger(id) || !id)
      return false;

    axios
      .get(SETTINGS.API_BASE_PATH + 'pages/' + id)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        cb(e);
      });
  },

  getPosts(limit = 5, lang = 'ja', cb) {
    axios
      .get(SETTINGS.API_BASE_PATH + 'posts?filter[orderby]=date&order=desc&lang=' + lang + '&per_page=99')
      .then(({ data: articles }) => {
        cb(articles);
        // axios
        //   .get(SETTINGS.API_BASE_PATH + 'tags')
        //   .then(({ data: tags }) => {
        //     const { id: topTagId } = tags.find(({ name }) => name === 'top');
        //     articles.sort((article) => {
        //       if (article.tags.includes(topTagId)) { return -1; }
        //       return 0;
        //     });
        //     cb(articles);
        //   })
      })
      .catch(e => {
        cb(e);
      });
  },
};
